import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiGetRequest,
  apiPostRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import KmPageTitle from "src/components/layout/KmPageTitle";
import { kmMessages } from "src/constant/Messages";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const MailingForm = ({
  systemInfo,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  setLogoutUser,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { folderId } = useParams(1);
  const { votingId } = useParams();
  const { newsId } = useParams();

  const [massageTypes, setMessageTypes] = useState(null);
  const [profiles, setProfiles] = useState(null);
  const [institutions, setInstitutions] = useState(null);
  const [workingGroups, setWorkingGroups] = useState(null);
  const [functions, setFunctions] = useState(null);
  const [voting, setVoting] = useState(null);
  const [votingMessageType, setVotingMessageType] = useState(null);
  const [news, setNews] = useState(null);
  const [newsMessageType, setNewsMessageType] = useState(null);

  const [dictionairesLoaded, setDictionairesLoaded] = useState(false);

  let pageTitle = "Powiadomienie";

  useEffect(() => {
    enableGlobalLoader();

    const dictPromises = [];
    dictPromises.push(
      apiGetRequest(apiEndpoints.getProfiles.path, true).then((data) => {
        setProfiles(data);
      })
      
    );
    dictPromises.push(
      apiGetRequest(apiEndpoints.getMessageType.path, true).then((data) => {
        setMessageTypes(data);
      })
      
    );
    dictPromises.push(
      apiGetRequest(apiEndpoints.getInstitutions.path, true).then((data) => {
        setInstitutions(data);
      })
      
    );
    dictPromises.push(
      apiGetRequest(apiEndpoints.getWorkingGroups.path, true).then((data) => {
        setWorkingGroups(data);
      })
     
    );
    dictPromises.push(
      apiGetRequest(apiEndpoints.getFunctions.path, true).then((data) => {
        setFunctions(data);
      })
      
    );
    if (rest.kmcontext === "voting" && votingId) {
      dictPromises.push(
        apiGetByIdRequest(
          apiEndpoints.getVotingBasicDetails.path,
          votingId,
          true
        ).then((data) => {
          setVotingDataForNotification(data);
        })
       
      );
    }
    if (rest.kmcontext === "news" && newsId) {
      dictPromises.push(
        apiGetByIdRequest(
          apiEndpoints.getNewsPreviewDetails.path,
          newsId,
          true
        ).then((data) => {
          setNewsDataForNotification(data);
        })
        
      );
    }

    Promise.all(dictPromises)
      .then((values) => {
        disableGlobalLoader();
        setDictionairesLoaded(true);
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        } else {
          displaySnackbar({
            isOpen: true,
            severity: "error",
            autoHideDuration: 5000,
            message:
              "Wystapił błąd podczas ładowania danych niezbędnych do wygenerowania powiadomienia.",
          });
          if (rest.kmcontext === "voting" && votingId) {
            navigate("/zarzadzanieglosowania/wtrakcie");
          } else {
            navigate("/dokumenty");
          }
        }
      });

    return () => {};
  }, []);

  useEffect(() => {
    if (rest.kmcontext === "voting" && votingId && massageTypes) {
      let votingMessageType = getMessageTypeByKey("notification_reminder");
      if (votingMessageType) {
        setVotingMessageType(votingMessageType);
      } else {
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 5000,
          message:
            "Wystapił błąd podczas ładowania rodzajów wiadomości, niezbędnych do wygenerowania powiadomienia.",
        });
        navigate("/zarzadzanieglosowania/wtrakcie");
      }
    }
    if (rest.kmcontext === "news" && newsId && massageTypes) {
      let newsMessageType = getMessageTypeByKey("news_newsletter");
      if (newsMessageType) {
        setNewsMessageType(newsMessageType);
      } else {
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 5000,
          message:
            "Wystapił błąd podczas ładowania rodzajów wiadomości, niezbędnych do wygenerowania powiadomienia.",
        });
        navigate("/aktualnosci/opublikowane");
      }
    }
    return () => {};
  }, [massageTypes]);

  const setVotingDataForNotification = (votingData) => {
    setVoting(votingData);
  };

  const setNewsDataForNotification = (newsData) => {
    setNews(newsData);
  };

  const getMessageTypeByKey = (key) => {
    let msgType = massageTypes.filter((messageType) => {
      return messageType.messageTag === key;
    });
    return msgType?.length > 0 ? msgType[0] : null;
  };

  const onSubmit = (
    formValues,
    content,
    functions,
    institutions,
    workingGroups,
    profiles,
    attachments,
    mailingStatus
  ) => {
    enableGlobalLoader();

    apiPostRequest(
      apiEndpoints.addMailing.path,
      {
        messageTypeId: votingMessageType
          ? votingMessageType.id
          : newsMessageType
          ? newsMessageType.id
          : formValues.messageType.id,
        subject: formValues.subject,
        body: content,
        documentStructNodeId: folderId,
        votingId: votingId,
        status: mailingStatus ? mailingStatus : null,
        functionIds: functions.map((funct) => funct.id),
        institutionIds: institutions.map((institution) => institution.id),
        workingGroupIds: workingGroups.map((workingGroup) => workingGroup.id),
        profileIds: profiles.map((profile) => profile.id),
        customEmails: formValues.customEmails,
        footerVersion:
          formValues.footer != "nofooter" ? formValues.footer : null,
        attachments: attachments.map((attachment) => {
          return {
            attachmentFile: {
              fileName: attachment.resName,
              fileData: attachment.fileData.data,
            },
          };
        }),
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "success",
          autoHideDuration: 3000,
          message: "Powiadomienie zostało utworzone",
        });
        navigate(`/dokumenty/${folderId}`);
      })
      .catch((error) => {

        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        } else if (error.response.status === 500 && error.response.data) {
          if (error.response.data.code === "MISSING_REQUIRED_FIELD_VALUE") {
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 8000,
              message: kmMessages.error.mailing.missing_recipients,
            });
          } 
        }
      });
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>{pageTitle}</KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form
            systemInfo={systemInfo}
            onSubmit={onSubmit}
            folderId={folderId}
            massageTypes={massageTypes}
            profiles={profiles}
            institutions={institutions}
            workingGroups={workingGroups}
            functions={functions}
            voting={voting}
            votingMessageType={votingMessageType}
            news={news}
            newsMessageType={newsMessageType}
            dictionairesLoaded={dictionairesLoaded}
          />
        </Box>
      </Container>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  systemInfo: state.globalData.systemInfo,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters))
});

export default connect(mapStateToProps, mapDispatchToProps)(MailingForm);
